import * as React from 'react';
import { useIntl } from '@leagueplatform/locales';
import type { DomainEntityConfiguration } from '@web-config-app/core';

export const useEntityReferenceControlState = ({
  domainEntity,
  isUsingConfigAppBackend = true,
}: {
  domainEntity: DomainEntityConfiguration;
  isUsingConfigAppBackend?: boolean;
}) => {
  const { formatMessage } = useIntl();
  const [isAddingById, setIsAddingById] = React.useState<boolean>(false);
  const [isAddingFromList, setIsAddingFromList] =
    React.useState<boolean>(false);

  const openChooseFromList = () => {
    setIsAddingFromList(true);
  };

  const closeChooseFromList = () => {
    setIsAddingFromList(false);
  };

  const openAddById = () => {
    setIsAddingById(true);
  };

  const closeAddById = () => {
    setIsAddingById(false);
  };

  const addItemTriggerList = isUsingConfigAppBackend
    ? [
        {
          buttonLabel: formatMessage(
            {
              id: 'CHOOSE_ENTITY_FROM_LIST',
            },
            {
              entityName: formatMessage(
                { id: domainEntity.labelKey },
                { count: 1 },
              ),
            },
          ),
          openFn: openChooseFromList,
        },
      ]
    : [
        {
          buttonLabel: formatMessage({
            id: 'ADD_BY_ID',
          }),
          openFn: openAddById,
        },
        {
          buttonLabel: formatMessage({
            id: 'CHOOSE_FROM_LIST',
          }),
          openFn: openChooseFromList,
        },
      ];

  return {
    isAddingById,
    isAddingFromList,
    openChooseFromList,
    closeChooseFromList,
    openAddById,
    closeAddById,
    addItemTriggerList,
  };
};
